import { useLocation, useNavigate } from 'react-router-dom';
import { APP_MANAGED_ROUTES } from 'common/app-managed-routes';
import { QUERY_PARAM_KEYS, QUERY_PARAM_MODAL_VALUE } from 'common/constants';

const getFlowKey = (url: string | undefined): string | undefined => {
  if (!url) return undefined;

  try {
    const target = new URL(url, window.location.origin);

    if (
      target.origin !== window.location.origin ||
      target.pathname !== APP_MANAGED_ROUTES.CHAT
    ) {
      return undefined;
    }

    return target.searchParams.get(QUERY_PARAM_KEYS.FLOW) ?? undefined;
  } catch {
    return undefined;
  }
};

/**
 * A flow destination is a full-screen route in the apps, but a modal on web.
 * Returns true when it claimed the click, so the caller skips the deeplink.
 */
export const useDfdFlowModalLauncher = () => {
  const location = useLocation();
  const navigate = useNavigate();

  return (url: string | undefined): boolean => {
    const flowKey = getFlowKey(url);

    if (!flowKey) return false;

    const params = new URLSearchParams(location.search);
    params.set(QUERY_PARAM_KEYS.MODAL, QUERY_PARAM_MODAL_VALUE.CHAT_SUPPORT);
    params.set(QUERY_PARAM_KEYS.FLOW, flowKey);
    navigate({ ...location, search: params.toString() });

    return true;
  };
};
